module.exports = __webpack_public_path__ + "img/fundo_paco_municipal.e9580116.jpg";